import { render } from "./Cards-tab-page.vue?vue&type=template&id=78edb22e&scoped=true"
import script from "./Cards-tab-page.vue?vue&type=script&lang=js"
export * from "./Cards-tab-page.vue?vue&type=script&lang=js"

import "./Cards-tab-page.vue?vue&type=style&index=0&id=78edb22e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78edb22e"]])

export default __exports__